import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { MarketingShell } from '@/components/marketing-shell';
import { capture } from '@/lib/posthog';
import { setPageSeo } from '@/lib/brand';
import { DOCUMENT_TYPES, DOCUMENT_TYPES_INDEX_SEO } from './data';

export function DocumentTypesIndexPage() {
  useEffect(() => {
    setPageSeo({
      title: DOCUMENT_TYPES_INDEX_SEO.title,
      description: DOCUMENT_TYPES_INDEX_SEO.description,
    });
    capture('doctypes_index_viewed', {});
  }, []);

  return (
    <MarketingShell>
      <main>
        <section className="border-b border-[var(--line)] bg-[var(--paper-sunk)]">
          <div className="mx-auto max-w-7xl px-4 pb-14 pt-16 sm:px-6 lg:px-8 lg:pt-20">
            <p className="font-mono text-[11px] font-semibold uppercase text-[var(--ember-text)]">
              Solutions / By document type
            </p>
            <h1 className="mt-5 max-w-3xl text-4xl leading-tight text-[var(--ink)] sm:text-5xl">
              PDF parsers organized by document type.
            </h1>
            <p className="mt-6 max-w-2xl text-lg leading-8 text-[var(--ink-mute)]">
              Start with a known schema, send a PDF, and get typed JSON back.
            </p>
          </div>
        </section>

        <section className="bg-[var(--paper)] py-14">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <ul className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
              {DOCUMENT_TYPES.map((dt, idx) => (
                <li key={dt.slug}>
                  <Link
                    to={`/document-types/${dt.slug}`}
                    onClick={() =>
                      capture('doctypes_index_card_clicked', {
                        slug: dt.slug,
                        position: idx + 1,
                      })
                    }
                    className="group flex h-full flex-col rounded-lg border border-[var(--line)] bg-[var(--paper-raised)] p-5 transition hover:border-[var(--selected-line)]"
                  >
                    <h2 className="text-[15px] font-semibold text-[var(--ink)] transition group-hover:text-[var(--ember-text)]">
                      {dt.docType}
                    </h2>
                    <p className="mt-2 text-[13px] leading-6 text-[var(--ink-mute)]">
                      {dt.outcome}
                    </p>
                    <div className="mt-4 inline-flex items-center gap-1.5 text-[12px] font-medium text-[var(--ember-text)]">
                      See parser
                      <ArrowRight className="h-3.5 w-3.5 transition group-hover:translate-x-0.5" />
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </section>
      </main>
    </MarketingShell>
  );
}
